import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/slides/fractions.jpg'


const _withScopeId = n => (_pushScopeId("data-v-cb3dde90"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  width: "540",
  height: "150",
  src: _imports_0,
  class: "GuideImage"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageGuideSlide = _resolveComponent("PageGuideSlide")!

  return (_openBlock(), _createBlock(_component_PageGuideSlide, { class: "Slide Fractions" }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.mixWB('FRACTIONS')), 1)
    ]),
    intro: _withCtx(() => [
      _createElementVNode("p", null, _toDisplayString(_ctx.mixWB('GUIDE_SLIDE_FRACTION_TEXT_1')), 1)
    ]),
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("p", null, _toDisplayString(_ctx.mixWB('GUIDE_SLIDE_FRACTION_TEXT_2')), 1)
    ]),
    _: 1
  }))
}